import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreateUnit } from 'src/features/units/api/useCreateUnit';
import { LIST_UNITS_RESOURCE } from 'src/features/units/api/useListUnits';
import UnitFormModal from 'src/features/units/components/forms/UnitFormModal';
import { unitsMessages } from 'src/features/units/utils/messages';

interface CreateUnitFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateUnitFormModal<TData>({ className, semantics }: CreateUnitFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateUnit({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_UNITS_RESOURCE] });
            toast({
                title: formatMessage(unitsMessages.createUnitSuccess),
                description: formatMessage(unitsMessages.createUnitSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <UnitFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(unitsMessages.addUnitSubtitle)}
        />
    );
}

export default CreateUnitFormModal;
